/**
 * Le "S" de Sirocco : deux volutes de vent enroulees autour d'un axe.
 *
 * C'est l'image de la maquette, detouree sur fond transparent, pour que
 * le trait soit exactement celui du logo d'origine. Sur l'illustration
 * d'un spot on l'affiche en blanc : le filtre transforme le cyan en
 * blanc sans avoir a maintenir deux fichiers.
 */

const MARK_SRC = '/illustrations/sirocco-mark.png';

/** Rapport largeur / hauteur du fichier source (91 x 175). */
const MARK_RATIO = 91 / 175;

export function SiroccoMark({
  size = 58,
  tone = 'brand',
}: {
  /** Hauteur de la marque, en points. */
  size?: number;
  /** `brand` la laisse cyan, `light` la passe en blanc. */
  tone?: 'brand' | 'light';
}) {
  return (
    <img
      src={MARK_SRC}
      alt="Sirocco"
      width={Math.round(size * MARK_RATIO)}
      height={size}
      style={{
        height: size,
        width: 'auto',
        filter: tone === 'light' ? 'brightness(0) invert(1)' : undefined,
      }}
    />
  );
}

/**
 * Le logo complet : la marque et le mot "SIROCCO" tres espace,
 * tel qu'il apparait sur les ecrans de connexion et d'inscription.
 */
export function SiroccoLogo({ markSize = 57 }: { markSize?: number }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
      <SiroccoMark size={markSize} />
      <span
        style={{
          fontSize: 14,
          fontWeight: 600,
          letterSpacing: '0.24em',
          // Compense l'interlettrage, qui ajoute un blanc a droite du mot.
          textIndent: '0.24em',
          color: 'var(--g-cyan)',
        }}
      >
        SIROCCO
      </span>
    </div>
  );
}
